import { textStyles as o } from "../../textStyles.es.js";
import { a as r } from "../../../chunk-OA3DH5LS-40f95340.js";
import { createMultiStyleConfigHelpers as i } from "@chakra-ui/react";
const t = r("toast").parts(
  "actionButton",
  "close",
  "container",
  "content",
  "description",
  "title"
), { defineMultiStyleConfig: a, definePartsStyle: e } = i(
  t.keys
), n = e(() => ({
  actionButton: {},
  close: {
    display: "inline-block",
    alignSelf: "center",
    margin: 1,
    marginLeft: "auto",
    svg: {
      boxSize: 4
    },
    '&[data-inline="false"]': {
      alignSelf: "flex-start",
      transform: "translate(4px, -4px)"
    }
  },
  container: {
    position: "relative",
    display: "flex",
    padding: 1,
    borderRadius: "8px",
    boxShadow: "200",
    spacing: "spacing-50",
    maxWidth: "500px"
  },
  content: {
    display: "flex",
    gap: "spacing-200",
    paddingY: "spacing-100",
    paddingX: "spacing-200",
    '&[data-inline="true"]': {
      flexDirection: "row",
      alignItems: "center"
    },
    '&[data-inline="false"]': {
      flexDirection: "column",
      alignItems: "flex-start"
    },
    ...o.md
  },
  title: {
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: "medium",
    color: "white"
  },
  description: {
    flex: 1
  }
})), p = a({
  baseStyle: n,
  variants: {
    default: {
      container: {
        backgroundColor: "primary.700",
        _dark: {
          backgroundColor: "white"
        }
      },
      title: {
        color: "white",
        _dark: {
          color: "primary.700"
        }
      },
      description: {
        color: "white",
        _dark: {
          color: "primary.700"
        }
      },
      closeIcon: {
        color: "white"
      }
    },
    info: {
      container: {
        backgroundColor: "rgba(127, 175, 220, 1)"
      },
      title: {
        color: "primary.700"
      },
      description: {
        color: "primary.700"
      },
      closeIcon: {
        color: "primary.700"
      }
    },
    success: {
      container: {
        backgroundColor: "success.500"
      },
      title: {
        color: "primary.700"
      },
      description: {
        color: "primary.700"
      },
      closeIcon: {
        color: "primary.700"
      }
    },
    warning: {
      container: {
        backgroundColor: "rgba(246, 153, 60, 1)"
      },
      title: {
        color: "primary.700"
      },
      description: {
        color: "primary.700"
      },
      closeIcon: {
        color: "primary.700"
      }
    },
    error: {
      container: {
        backgroundColor: "rgba(227, 92, 49, 1)"
      },
      title: {
        color: "primary.700"
      },
      description: {
        color: "primary.700"
      },
      closeIcon: {
        color: "primary.700"
      }
    }
  },
  defaultProps: {
    variant: "default"
  }
});
export {
  p as Snackbar,
  t as SnackbarAnatomy
};
//# sourceMappingURL=Snackbar.es.js.map
